import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  environmentalReports: [],
  isLoading: false,
  error: null,
  environmentalReportsDownload: [],
  isLoadingEnvironmentalReportsDownload: false,
};

export const getEnvironmentalReports: any = createAsyncThunk(
  "content/getEnvironmentalReports",
  async ({
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    asset = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
      asset,
    };
    const res = await axios.post(
      `/slpapp/Report/getEnvironmentalReport
`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const data = await res.data;
    return data;
  },
);

export const downloadEnvironmentalReportsFile: any = createAsyncThunk(
  "content/downloadEnvironmentalReportsFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      reportType,
      startDate,
      endDate,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getEnvironmentalReport
/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading environmental report:", error);
      throw error;
    }
  },
);

export const environmentalReportSlice = createSlice({
  name: "environmentalReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEnvironmentalReports.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getEnvironmentalReports.fulfilled, (state, action) => {
      state.isLoading = false;
      state.environmentalReports = action.payload;
    });
    builder.addCase(getEnvironmentalReports.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(downloadEnvironmentalReportsFile.pending, (state) => {
      state.isLoadingEnvironmentalReportsDownload = true;
    });
    builder.addCase(
      downloadEnvironmentalReportsFile.fulfilled,
      (state, action) => {
        state.isLoadingEnvironmentalReportsDownload = false;
        state.environmentalReportsDownload = action.payload;
      },
    );
    builder.addCase(
      downloadEnvironmentalReportsFile.rejected,
      (state, action) => {
        state.isLoadingEnvironmentalReportsDownload = false;
        state.error = action.error.message;
      },
    );
  },
});

export default environmentalReportSlice.reducer;
